import { render } from "./GameRulesMine.vue?vue&type=template&id=7152fab8&scoped=true"
import script from "./GameRulesMine.vue?vue&type=script&lang=js"
export * from "./GameRulesMine.vue?vue&type=script&lang=js"

import "./GameRulesMine.vue?vue&type=style&index=0&id=7152fab8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7152fab8"]])

export default __exports__